export default __webpack_public_path__ + "static/media/timer.10274570.svg";